export const round = (value: number, digit: number): number => {
  return Math.round(value * digit) / digit;
};
